export default __webpack_public_path__ + "static/media/message.e3b6acab.svg";